import { render, staticRenderFns } from "./MatchingProcessItems.vue?vue&type=template&id=44ba005e&scoped=true"
import script from "./MatchingProcessItems.vue?vue&type=script&lang=js"
export * from "./MatchingProcessItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ba005e",
  null
  
)

export default component.exports